// ----------------------------------------------------------------------
const user = JSON.parse(localStorage.getItem("user"))

const account = {
  displayName: `${user === null ? "" : user.data.last_name} ${user === null ? "" : user.data.first_name}`,
  email: user === null ? "" : user.data.email,
  role: user === null ? "" : user.data.role,
  photoURL: '/static/mock-images/avatars/avatar_default.jpg',
};

export default account;
